import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

// Interfaces for Overview API response
export interface MonthlyStats {
  monthly_dics: number[]
  monthly_notes: number[]
  monthly_quizzes: number[]
  monthly_figures: number[]
}

export interface LibraryOverview extends MonthlyStats {
  n_words: number
  last_word: string | null
  n_pairs: number
  last_pair: string | null
  n_dics: number
  last_dic: string | null
  n_notes: number
  last_note: string | null
  n_quizzes: number
  last_quiz: string | null
  n_figures: number
  last_figure: string | null
  n_teachers: number
  last_teacher: string | null
  n_courses: number
  last_course: string | null
  n_cats: number
  last_cat: string | null
  n_tags: number
  last_tag: string | null
}

export interface NetworkOverview {
  n_followers: number
  n_following: number
}

export type OverviewResponse = LibraryOverview | NetworkOverview

@Injectable({
  providedIn: 'root',
})
export class OverviewService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_overview(level: string): Observable<OverviewResponse> {
    this.logger.info('OVERVIEW | get_overview | level: ' + level)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: new HttpParams().set('level', level),
      withCredentials: true,
    }

    return this.http
      .get<OverviewResponse>(`${Backend.HOST_CONTAINER + Backend.OVERVIEW}`, httpOptions)
      .pipe(
        map((res: OverviewResponse) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('OVERVIEW | get_overview | catchError | errorMessage: ' + errorMessage)
          return of(errorMessage)
        }),
      )
  }
}
